import type { EmailShowImages } from '@services/api/email.api'
import { sanitizeHtmlContent } from '@utils/sanitizeHtml.util'

export const stripEmailImages = (
  html: string,
  clickablePlaceholder = false,
): string =>
  html.replace(
    /<img\b[^>]*>/gi,
    clickablePlaceholder
      ? [
          '<span class="mce-email-image-hidden mce-email-image-hidden--clickable"',
          ' role="button" tabindex="0" data-email-image-placeholder="true">',
          '<i class="mgc_pic_line"></i> Image hidden — click to show</span>',
        ].join('')
      : '<span class="mce-email-image-hidden">[image hidden]</span>',
  )

export const applyShowImagesToEmailHtml = (
  html: string,
  showImages?: EmailShowImages,
  revealed = false,
): string => {
  const cleanHtml = sanitizeHtmlContent(html)
  if (showImages === 'never') return stripEmailImages(cleanHtml, false)
  if (showImages === 'ask') {
    return revealed ? cleanHtml : stripEmailImages(cleanHtml, true)
  }
  return cleanHtml
}
